'use client';

import { useTranslations } from 'next-intl';
import { BeardmanTalking } from '~/components/Beardman/BeardmanTalking/BeardmanTalking';

export const NotForInternalUserMessage = () => {
  const t = useTranslations('SELECTION.MESSAGE');

  return (
    <div data-testid="not-for-internal">
      <BeardmanTalking
        title={t('NOT_FOR_INTERNAL_HEADER')}
        description={t('NOT_FOR_INTERNAL_BODY')}
      />
    </div>
  );
};
